<template lang="pug">
div
	mini-galeria(v-for="(galeria, i) in galerias", :key="galeria.GaleriaID", :galeria="galeria", @selecciona="selecciona($event)")
	modal-galeria(v-if="editarGaleria", @cerrar="editarGaleria = null", :id-galeria="editarGaleria")
</template>
<script>
import ModalGaleria from './modal-galeria'
import MiniGaleria from './mini-galeria.vue'
import API from '../../api'
export default {
	components: {
		'mini-galeria': MiniGaleria,
		'modal-galeria': ModalGaleria
	},
	data () {
		return {
			idGaleria: null,
			editarGaleria: null,
			galerias: []
		}
	},
	created () {
		const menu = {
			id: 'nuevaGaleria',
			nombre: 'Nueva galería',
			icono: 'fa fa-plus',
			callback: (e) => {
				this.editarGaleria = 'nueva'
			}
		}

		this.$store.commit('top/addMenu', menu)

		this.$store.commit('galerias/SET_GALERIA', null)

		this.getGalerias()
	},
	beforeDestroy () {
		this.$store.commit('top/delMenu', 'nuevaGaleria')
	},
	methods: {
		selecciona (i) {
			this.$router.push('/main/galerias/' + i)
		},
		detallesGaleria (ev, e) {
			ev.preventDefault()
			ev.stopPropagation()

			this.editarGaleria = e
		},
		getGalerias () {
			API.getGalerias(null)
				.then(res => {
					res.data.galeras = res.data.galerias.map(gal => {
						gal.PortadaUrl = (gal.PortadaID) ? '/src/modulos/galerias/php/api/thumb.php?ItemID=' + gal.PortadaID : '/src/modulos/galerias/static/noimage.png'
					})
					this.galerias = res.data.galerias
				})
				.catch(e => {
					console.error(e.response)
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/listado-galerias/listado-galerias.vue